export const eventLocations = {
  'United States': [
    { city: 'New York', adjustment: 22 },
    { city: 'San Francisco', adjustment: 28 },
    { city: 'Boston', adjustment: 18 },
    { city: 'Chicago', adjustment: 6 },
    { city: 'Washington, D.C.', adjustment: 14 },
    { city: 'Atlanta', adjustment: -4 },
    { city: 'Orlando', adjustment: -8 },
    { city: 'Dallas', adjustment: -6 }
  ],
  Canada: [
    { city: 'Toronto', adjustment: 8 },
    { city: 'Vancouver', adjustment: 19 },
    { city: 'Montreal', adjustment: 2 },
    { city: 'Calgary', adjustment: -3 }
  ],
  'United Kingdom': [
    { city: 'London', adjustment: 24 },
    { city: 'Manchester', adjustment: 7 },
    { city: 'Edinburgh', adjustment: 11 }
  ],
  Germany: [
    { city: 'Berlin', adjustment: 4 },
    { city: 'Munich', adjustment: 16 },
    { city: 'Frankfurt', adjustment: 9 }
  ],
  France: [
    { city: 'Paris', adjustment: 21 },
    { city: 'Lyon', adjustment: 5 },
    { city: 'Nice', adjustment: 13 }
  ],
  Switzerland: [
    { city: 'Zurich', adjustment: 31 },
    { city: 'Geneva', adjustment: 35 },
    { city: 'Basel', adjustment: 22 }
  ],
  Australia: [
    { city: 'Sydney', adjustment: 23 },
    { city: 'Melbourne', adjustment: 16 },
    { city: 'Brisbane', adjustment: 2 }
  ],
  Singapore: [
    { city: 'Singapore', adjustment: 26 }
  ],
  Japan: [
    { city: 'Tokyo', adjustment: 25 },
    { city: 'Osaka', adjustment: 10 },
    { city: 'Kyoto', adjustment: 15 }
  ],
  'United Arab Emirates': [
    { city: 'Dubai', adjustment: 20 },
    { city: 'Abu Dhabi', adjustment: 16 }
  ]
};

export const defaultLocation = {
  country: 'United States',
  city: 'Chicago',
  adjustment: 6
};

export const getCities = (country) =>
  eventLocations[country] || [];

export const getLocation = (country, city) =>
  getCities(country).find((location) => location.city === city) ||
  getCities(country)[0] ||
  defaultLocation;